// @flow

import * as React from "react";
import { useSelector } from "react-redux";

import Config from "../../constants/Config";

import { getMembershipDateString } from "../../utils/date";
import Modal from "../organisms/Modal";

type PropsType = {
    activeOrder: any,
    active: boolean,
    onClose: Function,
};

const OrderDetailModal = (props: PropsType): React.Node => {
    const pickupAddress = useSelector((state: any): any => {
        return state.options.store_pickup_address;
    });
    let subTotal = 0;
    let discount = 0;
    let refundTotal = 0;

    props.activeOrder.line_items.forEach(item => {
        subTotal = subTotal + Number(item.subtotal) + Number(item.subtotal_tax);
    });
    props.activeOrder.coupon_lines.forEach(item => {
        discount = discount + Number(item.discount) + Number(item.discount_tax);
    });

    if (props.activeOrder.refunds && props.activeOrder.refunds.length > 0) {
        props.activeOrder.refunds.forEach(item => {
            refundTotal = (refundTotal + Number(item.total)) * -1;
        });
    }

    // Delivery or Pickup
    const isPickup =
        props.activeOrder.shipping_lines[0] &&
        props.activeOrder.shipping_lines[0].method_id === "local_pickup";

    return (
        <Modal
            aside={true}
            active={props.active}
            className="order-detail-modal"
            onClose={props.onClose}
            onOverlayClick={props.onClose}
        >
            <Modal.Header>Order details</Modal.Header>
            <Modal.Content>
                <div className="container-fluid order-detail-modal__content__inner">
                    <p className="order-detail-modal__heading">
                        <strong>Order #{props.activeOrder.id}</strong> was
                        placed on{" "}
                        <strong>
                            {getMembershipDateString(
                                props.activeOrder.date_created,
                                "yyyy-MM-dd'T'HH:mm:ss"
                            )}
                        </strong>{" "}
                        and is currently{" "}
                        <strong className="status">
                            {props.activeOrder.status}
                        </strong>
                    </p>
                    <div className="order-detail-modal__details">
                        <div className="order-detail-modal__details__header">
                            <div>Product</div>
                            <div>Total</div>
                        </div>
                        <div className="order-detail-modal__details__body">
                            {props.activeOrder.line_items.map(product => {
                                return (
                                    <div
                                        key={product.id}
                                        className="order-detail-modal__details__product__row"
                                    >
                                        <div className="order-detail-modal__details__product__name">
                                            {product.quantity} x {product.name}
                                        </div>
                                        <div className="order-detail-modal__details__product__cost">
                                            $
                                            {parseFloat(
                                                parseFloat(product.subtotal) +
                                                    parseFloat(
                                                        product.subtotal_tax
                                                    )
                                            ).toFixed(2)}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="order-detail-modal__details__footer">
                            <div className="order-detail-modal__details__footer__row">
                                <div className="order-detail-modal__details__footer__title">
                                    Subtotal
                                </div>
                                <div>${subTotal.toFixed(2)}</div>
                            </div>
                            {props.activeOrder.discount_total > 0 ? (
                                <div className="order-detail-modal__details__footer__row">
                                    <div className="order-detail-modal__details__footer__title">
                                        Promo code
                                    </div>
                                    <div>
                                        {"-$" + parseFloat(discount).toFixed(2)}
                                    </div>
                                </div>
                            ) : null}
                            {props.activeOrder.shipping.postcode !== "0000" ? (
                                <div className="order-detail-modal__details__footer__row">
                                    <div className="order-detail-modal__details__footer__title">
                                        Delivery
                                    </div>
                                    <div>
                                        $
                                        {parseFloat(
                                            Number(
                                                props.activeOrder.shipping_tax
                                            ) +
                                                Number(
                                                    props.activeOrder
                                                        .shipping_total
                                                )
                                        ).toFixed(2)}
                                    </div>
                                </div>
                            ) : null}
                            <div className="order-detail-modal__details__footer__row">
                                <div className="order-detail-modal__details__footer__title">
                                    Payment method
                                </div>
                                <div>
                                    {props.activeOrder.payment_method === "eway"
                                        ? "Credit Card"
                                        : props.activeOrder
                                              .payment_method_title}
                                </div>
                            </div>
                            <div className="order-detail-modal__details__footer__row">
                                <div className="order-detail-modal__details__footer__title">
                                    Total
                                </div>
                                <div className="order-detail-modal__details__footer__summary">
                                    <div>${props.activeOrder.total}</div>
                                    <div>
                                        (Includes ${props.activeOrder.total_tax}{" "}
                                        GST)
                                    </div>
                                </div>
                            </div>
                            {props.activeOrder.refunds &&
                            props.activeOrder.refunds.length > 0 ? (
                                <div className="order-detail-modal__details__refund">
                                    <div className="order-detail-modal__details__refund__title">
                                        Refund total
                                    </div>
                                    <div className="order-detail-modal__details__refund__summary">
                                        <div>-${refundTotal.toFixed(2)}</div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="order-detail-modal__address">
                            <div className="order-detail-modal__address__title">
                                Billing address
                            </div>
                            <div className="order-detail-modal__address__name">
                                {props.activeOrder.billing.first_name}{" "}
                                {props.activeOrder.billing.last_name}
                            </div>
                            {props.activeOrder.billing.postcode !== "0000" ? (
                                <div className="order-detail-modal__address__phone">
                                    {props.activeOrder.billing.address_1 !==
                                    Config.wcEmptyField ? (
                                        <div>
                                            {
                                                props.activeOrder.billing
                                                    .address_1
                                            }
                                        </div>
                                    ) : null}
                                    {props.activeOrder.billing.address_2 !==
                                    Config.wcEmptyField ? (
                                        <div>
                                            {
                                                props.activeOrder.billing
                                                    .address_2
                                            }
                                        </div>
                                    ) : null}
                                    <div>{`${
                                        props.activeOrder.billing.city !==
                                        Config.wcEmptyField
                                            ? props.activeOrder.billing.city +
                                              " "
                                            : ""
                                    } ${props.activeOrder.billing.state} ${
                                        props.activeOrder.billing.postcode
                                    }`}</div>
                                </div>
                            ) : null}
                            <div className="order-detail-modal__address__phone">
                                {props.activeOrder.billing.phone}
                            </div>
                            <div className="order-detail-modal__address__email">
                                {props.activeOrder.billing.email}
                            </div>
                        </div>

                        {
                            //  Delivery or Pickup
                        }
                        {isPickup ? (
                            <div className="order-detail-modal__address">
                                <div className="order-detail-modal__address__title">
                                    Pick up from Store
                                </div>
                                <div className="order-detail-modal__address__name">
                                    {pickupAddress}
                                </div>
                            </div>
                        ) : props.activeOrder.shipping.postcode !== "0000" ? (
                            <div className="order-detail-modal__address">
                                <div className="order-detail-modal__address__title">
                                    Delivery address
                                </div>
                                <div className="order-detail-modal__address__name">
                                    {props.activeOrder.shipping.first_name}{" "}
                                    {props.activeOrder.shipping.last_name}
                                </div>
                                <div className="order-detail-modal__address__phone">
                                    {props.activeOrder.shipping.address_1 !==
                                    Config.wcEmptyField ? (
                                        <div>
                                            {
                                                props.activeOrder.shipping
                                                    .address_1
                                            }
                                        </div>
                                    ) : null}
                                    {props.activeOrder.shipping.address_2 !==
                                    Config.wcEmptyField ? (
                                        <div>
                                            {
                                                props.activeOrder.shipping
                                                    .address_2
                                            }
                                        </div>
                                    ) : null}
                                    <div>{`${
                                        props.activeOrder.shipping.city !==
                                        Config.wcEmptyField
                                            ? props.activeOrder.shipping.city +
                                              " "
                                            : ""
                                    } ${props.activeOrder.shipping.state} ${
                                        props.activeOrder.shipping.postcode
                                    }`}</div>
                                </div>
                                <div className="order-detail-modal__address__phone">
                                    {props.activeOrder.shipping.phone}
                                </div>
                                <div className="order-detail-modal__address__email">
                                    {props.activeOrder.billing.email}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </Modal.Content>
        </Modal>
    );
};

export default OrderDetailModal;
